import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsString,
  IsUUID,
  IsOptional,
  MaxLength,
  Matches,
  IsBoolean,
} from 'class-validator'

/**
 * DTO for creating a new concept
 */
export class CreateConceptDto {
  @ApiProperty({
    description: 'Unique code for the concept (e.g., MATH-6-DEC)',
    example: 'MATH-6-DEC',
    maxLength: 128,
  })
  @IsString()
  @MaxLength(128)
  @Matches(/^[A-Z0-9-_]+$/, {
    message:
      'Code must contain only uppercase letters, numbers, hyphens, and underscores',
  })
  code!: string

  @ApiProperty({
    description: 'Display label for the concept',
    example: 'Nombres décimaux',
    maxLength: 255,
  })
  @IsString()
  @MaxLength(255)
  label!: string

  @ApiPropertyOptional({
    description: 'Detailed description of the concept',
    example: 'Partie entière et décimale',
  })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({
    description: 'Synonyms for the concept (comma-separated or array)',
    example: ['decimal numbers', 'fractions'],
    oneOf: [{ type: 'string' }, { type: 'array', items: { type: 'string' } }],
  })
  @IsOptional()
  synonyms?: string[] | string // Handle both for flexibility or strictly array if backend expects it

  @ApiProperty({
    description: 'URL-friendly slug',
    example: 'nombres-decimaux-6',
    maxLength: 255,
  })
  @IsString()
  @MaxLength(255)
  @Matches(/^[a-z0-9-]+$/, {
    message: 'Slug must contain only lowercase letters, numbers, and hyphens',
  })
  slug!: string

  @ApiProperty({
    description: 'Subject UUID this concept belongs to',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsUUID()
  subjectId!: string

  @ApiPropertyOptional({
    description: 'Is archived',
    example: false,
  })
  @IsOptional()
  @IsBoolean()
  isArchived?: boolean
}
